import React, { Component } from 'react';
import Select from 'react-select';
import axios from 'axios'
import { Table} from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';

class ViewLargeCustomers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerName: '',
            phone1: '',
            contactPerson1: '',
            loading: false,
            customers: []
        }
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                    this.getCustomerList();
                }



            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
       // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }


    

    getCustomerList = () => {
        console.log("++++++++:getCustomerList");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getCustomerList', {
            apiKey: "PrintB@da7",
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. adding customer");
                    this.setState({
                        customers: response.data.customers
                    })
                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    render() {

        const rows = this.state.customers.length > 0
            ? this.state.customers.map((item) =>
                <Table.Row>
                    <Table.Cell> {item.idlargeprojectcustomer} </Table.Cell>
                    <Table.Cell> {item.customername} </Table.Cell>
                    <Table.Cell> {item.phone1} </Table.Cell>
                    <Table.Cell> {item.contactperson1} </Table.Cell>
                </Table.Row>)
            : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <h2>CUSTOMERS</h2>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Id</Table.HeaderCell>
                            <Table.HeaderCell>Customer Name</Table.HeaderCell>
                            <Table.HeaderCell>Phone 1</Table.HeaderCell>
                            <Table.HeaderCell>Contact Person</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {rows}
                    </Table.Body>

                </Table>


            </div>
        );
    }
}

export default ViewLargeCustomers;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ViewLargeCustomers.js